import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { StepWrapper, StepUnderline, StepLabelWrapper, Counter } from './styled';
const createStepComponent = ({ getLabelColor, getColor, underline, componentName, disabled = false }) => {
    const Step = React.memo(function Step({ id, stepNumber, title, onClick }) {
        return (_jsxs(StepWrapper, { onClick: !disabled ? onClick : undefined, disabled: disabled, children: [_jsxs(StepLabelWrapper, { $getLabelColor: getLabelColor, "data-testid": `${id.toLowerCase()}-step`, children: [_jsx(Counter, { $getColor: getColor, children: stepNumber }), title] }), underline ? _jsx(StepUnderline, { $getColor: getColor }) : null] }));
    });
    Step.displayName = componentName;
    return Step;
};
export const Step = {
    Complete: createStepComponent({
        getLabelColor: ({ theme, hover }) => (hover ? theme.colors.black_1 : theme.colors.grey100_1),
        getColor: ({ theme }) => theme.colors.grey100_1,
        componentName: 'CompleteStep',
    }),
    Current: createStepComponent({
        getLabelColor: ({ theme, hover }) => (hover ? theme.colors.blackDark_1 : theme.colors.black_1),
        getColor: ({ theme }) => theme.colors.main,
        componentName: 'CurrentStep',
        underline: true,
    }),
    NextStep: createStepComponent({
        getLabelColor: ({ theme, hover }) => (hover ? theme.colors.grey100_1 : theme.colors.grey70_1),
        getColor: ({ theme }) => theme.colors.grey70_1,
        componentName: 'NextStep',
    }),
    Disabled: createStepComponent({
        getLabelColor: ({ theme, hover }) => (hover ? theme.colors.grey100_1 : theme.colors.grey70_1),
        getColor: ({ theme }) => theme.colors.grey30_1,
        componentName: 'DisabledStep',
        disabled: true,
    }),
};
